<h1 mat-dialog-title>You password has expired.</h1>
<h4 mat-dialog-title>Please change it.</h4>

<form [formGroup]="form" (submit)="changePassword()" class="form-width">
	<mat-dialog-content>
		<div class="row">

			<mat-form-field class="col-lg-12">
				<mat-label>Old Password</mat-label>
				<input matInput [type]="hide ? 'password' : 'text'" placeholder="Old Password"
					formControlName="oldPassword" />
				<button type="button" mat-icon-button matSuffix (click)="toggleHide()"
					[attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" tabindex="-1">
					<mat-icon>{{hide ? "visibility_off" : "visibility"}}</mat-icon>
				</button>
			</mat-form-field>

			<div class="col-lg-12">
				<input-password [form]="form" [controlName]="'password'" [matLabel]="'New Password'"
					[placeholder]="'New Password'" [(passwordToConfirm)]="passwordToConfirm"></input-password>
			</div>

			<div class="col-lg-12">
				<input-password-confirm [form]="form" [controlName]="'confirmPassword'" [targetControlName]="'password'"
					[matLabel]="'Confirm New Password'" [placeholder]="'Confirm New Password'"
					[passwordToConfirm]="passwordToConfirm"></input-password-confirm>
			</div>

			<div class="col-lg-12">
				<app-msg [msg]="msg"></app-msg>
			</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button type="submit" mat-raised-button color="primary" [disabled]="!form.valid || isLoading">

			<mat-icon *ngIf="isLoading && !msg.SUCCESS">
				<mat-spinner *ngIf="isLoading" diameter="20"> </mat-spinner>
			</mat-icon>
			<mat-icon *ngIf="msg.SUCCESS">
				done
			</mat-icon>
			Change Password
		</button>
	</mat-dialog-actions>
</form>